import MainNav from './MainNav'
import MainFooter from './MainFooter'
import SitconMap from './SitconMap'
import SubTable from './SubTable'
import Fancybox from './Fancybox'
import SubTableCol from './SubTableCol.vue'
import SubTableRow from './SubTableRow.vue'
import MobileRow from './MobileRow.vue'

export default {
  MainNav,
  MainFooter,
  SitconMap,
  SubTable,
  Fancybox,
  SubTableCol,
  SubTableRow,
  MobileRow
}



// WEBPACK FOOTER //
// ./src/components/_index.js